<template>
    <div class="cp-request">
        <div class="pt-5" v-if="loader">
            <Loader class="mt-5"/>
        </div>
        <div class="h-100 position-relative" :class="{hidden: loader}">
            <div class="d-flex h-100">
                <PartnerPart 
                    :show-template='!loader && campaigns && !!campaigns.length'
                    :owner-campaign = "request.owner && request.owner.selectedCampaign"
                    @newPartner="request.partner = $event"
                    :pending = "pending"
                />
                <div class="w-50 column" v-if="!loader && request.partner.campaign && campaigns.length">
                    <div class="side-container mx-auto">
                        <div v-if="isOwner" class="side-container mx-auto">
                            <p class="lab c6 mb-0">Can't send CP Request to your campaign!</p>
                            <button
                                @click="hideModal"
                                id="close-button-cp-modal"
                                class="phiolet_button p1b w-100 mt-5"
                                type="button">
                                    Close
                            </button>
                        </div>
                        <div v-else>    
                            <OwnerPart
                                :hide-modal="hideModal"
                                :campaigns = 'campaigns'
                                :partner = 'request.partner'
                                @newOwner="request.owner = $event"
                                :pending = "pending"
                                @setPending = "pending = $event"
                            />
                            <SubmitButton  :request = "request" :hide-modal="hideModal" />
                        </div>
                    </div>
                </div>
                <div v-if="!loader && campaigns && !campaigns.length" class="empty-camp d-flex align-items-center justify-content-center">
                    <div class="empty-place-container flex-column" style="width: 390px">
                        <div>
                            <CpModalZero/>
                        </div>
                        <div class="mt-4">
                            <router-link :to="{path: '/wizard', query: {from: $route.fullPath}}">
                                <button id="request-cp-modal" class="c16 p2b phiolet_button w-100" style="height: 48px" @click="trackEvent">
                                    Add Your Campaign
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import PartnerPart from "./PartnerPart";
import OwnerPart from "./OwnerPart";
import { CpModalZero, Loader } from '../../components/Icons'
import SubmitButton from './SubmitButton'

import { ref, computed } from '@vue/composition-api';
import { cpRequestUseCase } from '../../core/usecases'
import { provideErrors } from '../../core/providers'
import { useCampaigns, useUserId } from '../../core/hooks'

export default {
    name: 'CpRequest',
    props: {
        hideModal: Function
    },
    components: {
        PartnerPart,
        OwnerPart,
        CpModalZero,
        Loader,
        SubmitButton
    },
    setup(props, context) {

        provideErrors([
            'all-spots-are-taken',
            'all-spots-are-taken-partner',
            'no-update-date',
            'no-update-date-partner',
            'pick-spot',
            'pick-spot-partner',
            'pick-date',
            'pick-date-partner',
            'already-requested',
            'already-requested-partner',
            'pick-your-campaign', 
            'long-comment'
        ]);

        const { userId } = useUserId();

        const pending = ref(false)

        const { campaigns, loader } = useCampaigns(userId);

        const request = ref({
            partner: {},
            owner: {},
        })

        const trackEvent = () => {
            context.root.$sendMixpanelEvent('Add Wizard Opened', {
                Location: 'CpRequest Modal'
            })
            context.root.$ga.event('Add Wizard', 'Page Opened', 'Location', 'CpRequest Modal')
        }

        const isOwner = computed(() => request.value.partner.campaign && request.value.partner.campaign.author_id === userId)

        return {
            campaigns,
            loader,
            isOwner,
            request,
            trackEvent,
            pending
        }
    }
}

</script>

<style lang="scss">

    // Error Css
    .error-state-texts {
        color: #FA5C7C !important;
        font-size: 11px;
        line-height: 15px;
    }

    // .overflow-hidden {
    //     overflow: hidden;
    // }

    .error-state {
        position: relative;

        .spots-list {
            position: relative;
            &::after {
                content: url(/icons/warning.svg);
                position: absolute;
                left: 100%;
                top: 100%;
                transform: translate(0, -100%);
            }
        }
        .warning-icon {
            left: 100%;
            top: 50%;
            transform: translate(50%, 0);
        }
        p {
            color: #FA5C7C !important;
        }
        .dropdown {
            button.dropdown-toggle.btn {
                border: 1px solid #FA5C7C !important;
            }
        }
        textarea {
            border: 1px solid #FA5C7C !important;
        }
    }
</style>

<style scoped lang="scss">
    .cp-request {
        width: 577px;
        height: 436px;
        background: #FFFFFF;
        box-shadow: 0px 0px 75px rgba(0, 0, 0, 0.17);
        border-radius: 10px;

        .column {
            height: 100%;
            .side-container {
                margin-top: 28px;
                width: 207px;
            }
        }

        .gray-background {
            background: #F9F9F9;
            border-radius: 10px 0 0 10px;
        }

        .empty-camp {
            width: 580px;
            height: 435px;
            background: #FFFFFF;
            box-shadow: 0px 0px 75px rgba(0, 0, 0, 0.17);
            border-radius: 10px;
        }
    }

    .hidden {
        visibility: hidden
    }

    @media (max-width: 991px) {
        .cp-request {
            width: 100%;
        }
    }
</style>
